<template>
  <h4 v-if="props.edit">Edit Record</h4>
  <h4 v-else>Add Application</h4>
  <v-row>
    <v-col>
      <v-text-field
        class="pa-2"
        label="Application Name (Required)"
        v-model="fields['name']"
        density="compact"
        hide-details="auto"
      />

      <v-text-field
        class="pa-2"
        label="Patch Definition ID"
        v-model="fields['patchDefinitionId']"
        density="compact"
        hide-details="auto"
      />
      <!-- <v-text-field
    class="mt-2"
    label="recipie Name (Required)"
    v-model="fields['recipeName']"
    density="compact"
    hide-details="auto"
  /> -->
      <v-text-field
        class="pa-2"
        label="Install Path (Required)"
        v-model="fields['installPath']"
        density="compact"
        hide-details="auto"
      />
      <v-text-field
        v-if="props.edit"
        class="pa-2"
        label="Recipe Folder Name"
        v-model="fields['recipeName']"
        density="compact"
        hide-details="auto"
      />
      <v-text-field
        class="pa-2"
        label="Build Script Name Path (Required)"
        v-model="fields['buildScript']"
        density="compact"
        hide-details="auto"
      />
      <v-select
        class="pa-2"
        label="CFVersionSetting"
        :items="['CFBundleShortVersionString', 'CFBundleVersion']"
        v-model="fields['CFVersionSetting']"
      ></v-select>

      <!-- <v-text-field
    class="mt-2"
    label="CFVersionSetting"
    v-model="fields['versionKey']"
    density="compact"
    hide-details="auto"
    readonly
    @click="showRow = true"
  /> -->
      <!-- <v-radio-group v-if="showRow" v-model="fields['versionKey']">
    <v-radio label="CFBundleVersion" value="CFBundleVersion"></v-radio>
    <v-radio
      label="CFBundleShortVersionString"
      value="CFBundleShortVersionString"
    ></v-radio>
  </v-radio-group> -->

      <v-checkbox
        class="pa-2"
        label="Force Universal Architecture"
        v-model="fields['forceUniversal']"
        density="compact"
      ></v-checkbox>

      <v-file-input
        class="pa-2"
        label="AutoPkg Recipie Zip (Required)"
        v-model="fields['zipLocation']"
        density="compact"
        hide-details="auto"
        accept=".zip"
      />

      <v-card class="pa-2">
        <v-card-title> Blocking Applications (Kill Apps) </v-card-title>
        <v-card-text v-if="fields.killApps">
          <v-alert
            v-if="!fields.killApps.length"
            type="error"
            text="Warning! No Blocking applications are defined. Patch24 will
            automatically install updates whether the app is running or not."
          >
          </v-alert>
          <v-sheet
            v-for="(item, index) in fields.killApps"
            v-bind:key="item"
            class="pa-2"
            border
            rounded
            :elevation="1"
          >
            Blocking App {{ index + 1 }}
            <v-icon class="align-center" color="" @click="removeRow(index)"
              >mdi mdi-delete</v-icon
            >
            <v-text-field
              class="mt-2"
              label="Application Name (Include '.app') (Required)"
              v-model="item['appName']"
              density="compact"
              hide-details="auto"
            />
            <v-text-field
              class="mt-2"
              label="Application Bundle ID (Required)"
              v-model="item['bundleId']"
              density="compact"
              hide-details="auto"
            />
          </v-sheet>

          <div @click="addRow()">
            Add Blocking Application
            <v-icon color="">mdi-plus-box</v-icon>
          </div>
        </v-card-text>
      </v-card>

      <v-row class="mt-2">
        <v-col cols="auto"
          ><v-btn :disabled="saving" @click="saveClicked()">Save</v-btn></v-col
        >
        <v-col v-if="props.edit" class="text-left" cols="auto"></v-col>
        <v-col><v-spacer></v-spacer></v-col>
        <v-col class="text-right"
          ><v-btn @click="$emit('cancel')">Cancel</v-btn></v-col
        >
      </v-row>
      <v-alert class="mt-3" v-if="alert != ''" type="error" icon="mdi-alert">{{
        alert
      }}</v-alert>
    </v-col>
  </v-row>

  <v-dialog v-model="saveConfirmationShow" max-width="600">
    <v-card>
      <v-card-title>Save Confirmation</v-card-title>
      <v-card-text>
        <v-alert
          type="info"
          text="Note that saving will set the app to unapproved requiring it to be approved again"
        ></v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="saveNewPatch()">Yes</v-btn>
        <v-btn @click="saveConfirmationShow = false">No</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, reactive, onMounted, defineProps, defineEmits } from "vue";
const fields = reactive({});
import { apiQuery } from "@/api/j24api";
const alert = ref("");
const saving = ref(false);
const loading = ref(false);
const showRow = ref(false);
var blockingData = ref([]);

const props = defineProps({
  edit: Boolean,
  item: {},
  email: String,
  currentData: Object,
});

const emit = defineEmits(["updated", "cancel", "loading", "loadingDone"]);

// onMounted(async () => {
//   console.log("---");
//   console.log(props.email);
// });

onMounted(() => {
  fields["CFVersionSetting"] = "CFBundleShortVersionString";
  if (props.edit) {
    console.log("Editing", props.item);
    // Loop through the object and set the fields
    for (const key in props.item) {
      fields[key] = props.item[key];
    }
  }
  if (!fields["killApps"]) {
    fields["killApps"] = [];
  }
});

const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

async function addRow() {
  fields.killApps.push({ appName: "", bundleId: "" });
}

function removeRow(item) {
  fields.killApps.splice(item, 1);
}

const saveConfirmationShow = ref(false);

function saveClicked() {
  if (props.edit) {
    saveConfirmationShow.value = true;
  } else {
    saveNewPatch();
  }
}

async function saveNewPatch() {
  saveConfirmationShow.value = false;
  loading.value = true;
  saving.value = true;
  alert.value = "";
  var fieldNumber = 0;
  for (var field in fields) {
    fieldNumber = fieldNumber + 1;
  }
  if (fieldNumber < 4) {
    alert.value = "Please fill in each field.";
    saving.value = false;
    return;
  }
  try {
    console.log("ZipLocation", fields.zipLocation);
    // if fileds.zipLocation is an array, get the first element
    if (Array.isArray(fields.zipLocation)) {
      fields.zipLocation = fields.zipLocation[0];
    }
    fields["fileData"] = await getBase64(fields.zipLocation);
  } catch {
    if (!props.edit) {
      alert.value = "Unable to parse zip file";
      saving.value = false;
      return;
    }
  }

  if (!fields["installPath"].includes(".")) {
    alert.value =
      "Please give the full install path, eg /Applications/Company Portal.app";
    saving.value = false;
    return;
  }

  var addedDate = new Date(Date.now()).toLocaleString();

  fields["addedBy"] = props.email;
  fields["addedOn"] = addedDate;
  fields["apiAction"] = "AddPatchItem";
  if (props.edit) {
    fields["apiAction"] = "UpdatePatchItem";
    fields["id"] = props.item.id;
  }
  fields["type"] = "recipe";
  //fields["killApps"] = blockingData.value;
  // if (fields["forceUniversal"] == true) {
  //   fields["forceUniversal"] = true;
  // } else {
  //   fields["forceUniversal"] = false;
  // }

  try {
    const result = await apiQuery("ELA", "patching/patchitems", fields);
    loading.value = false;
    if (result.statusCode != 200) {
      alert.value = "Error saving record - " + result.body;
      saving.value = false;
      loading.value = false;
    } else {
      emit("updated");
    }
  } catch (error) {
    alert.value = "Error saving record - " + error;
    saving.value = false;
    loading.value = false;
    loading.value = false;
  }
}
</script>
